import { useEffect, useState } from 'react';
import api, { brandingApi } from '@verlo/shared/services/api';
import NoOrganisationPage from '../pages/NoOrganisationPage';
import { BackOfficeLoading } from '../routes/guards';
import { isUnknownHost, isUnknownOrganisationError } from '../lib/host';

/**
 * Shows `NoOrganisationPage` instead of the app on an address with no organisation behind it
 * (#181, `lib/host.js`).
 *
 * It asks `GET /branding` before rendering anything, so the login form never flashes up first.
 * That call is public and cached for a minute. If it fails (offline, the API down), the app
 * renders as it always has, and its pages say what is wrong. It then watches every API answer
 * for the scoped 404, which turns the page on mid-session, when an org is removed under
 * someone signed in.
 */
const HostGate = ({ children }) => {
  const [checked, setChecked] = useState(false);
  const [unknown, setUnknown] = useState(false);

  useEffect(() => {
    let alive = true;
    brandingApi.get()
      .then((res) => { if (alive && isUnknownHost(res.data)) setUnknown(true); })
      .catch(() => {})
      .finally(() => { if (alive) setChecked(true); });

    const watch = api.interceptors.response.use(undefined, (error) => {
      if (isUnknownOrganisationError(error)) setUnknown(true);
      return Promise.reject(error);
    });
    return () => {
      alive = false;
      api.interceptors.response.eject(watch);
    };
  }, []);

  if (unknown) return <NoOrganisationPage />;
  if (!checked) return <BackOfficeLoading />;
  return children;
};

export default HostGate;
